export default __webpack_public_path__ + "static/media/logo_ul_h_en_rgb.ae26a288.png";